<template>
    <Modal
        v-model:show="show"
        @close="$emit('close')">
        <div class="d-flex flex-column align-items-center py-4">
            <div class="send-container">
                <div class="icon-send-background my-4">
                    <i class="fas fa-paper-plane icon-send"></i>
                </div>
                <h2>{{ $t('emails.verify.send_link') }}!</h2>
                <div class="text-center">
                    <p>{{ $t('emails.verify.send_obs') }}.</p>
                </div>
            </div>
        </div>
    </Modal>
</template>

<script>

import Modal from '../../argon/components/Modal';

export default {
    emits: ['close', 'input', 'update:modelValue'],
    name: 'VerifyEmailSending',
    components: {
        Modal,
    },
    props: {
        modelValue: {
            type: Boolean,
            require: true,
        },
    },
    computed: {
        show: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
        },
    },
};
</script>

<style scoped>
.icon-send-background {
    height: 60px;
    width: 60px;
    background-color: #009be4;
    border-radius: 50px;

    display: flex;
    justify-content: center;
    align-items: center;
}
.icon-send {
    font-size: 35px;
    color: #fff;
}
.send-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 70%;
}
.another-send {
    font-weight: 100;
    font-size: 13px;
}
</style>
